import Vue from 'vue'
import Vuex from 'vuex'
import $ from 'jquery'
import file from '../../layout/store/file'
import deal from './deal'
import event from './event'
import User from "../../layout/assets/js/user";

Vue.use(Vuex)
const token = $('#vitrine').data('token')
const errors = $('#vitrine').data('errors')
const user = $('#vitrine').data('user')
let currentUser = new User()
if (user && user !== {}) {
    currentUser.id = user.id
    currentUser.username = user.name
    currentUser.email = user.email
    currentUser.picture = user.image
}

const state = {
    uriApp: '', //'http://home.honoraclub.com',//'http://demoh.honoraclub.com',
    tokenCrsf: token,
    errors: errors,
    currentUser: currentUser,
    viewPartner: {partners: []},
    progressState: {value: 0, length: 0},
    items: [],
    drawer: false,
    loadingRegister: false,
    loadingDeal: false
}

const getters = {
    progressState: (state) => state.progressState,
    loadingRegister: (state) => state.loadingRegister,
    loadingDeal: (state) => state.loadingDeal,
    items: (state) => state.items,
    drawer: (state) => state.drawer,
    uriApp: (state) => state.uriApp,
    tokenCrsf: (state) => state.tokenCrsf,
    currentUser: (state) => state.currentUser,
    viewPartner: (state) => state.viewPartner
}

const mutations = {
    SET_VIEW_PARTNER(state, viewPartner) {
        state.viewPartner = viewPartner
    },
    SET_LOADING_REGISTER(state) {
        state.loadingRegister = !state.loadingRegister
    },
    SET_LOADING_DEAL(state, value) {
        state.loadingDeal = value
    },
    SET_ITEM_LINK_PARTNER(state, link) {
        state.items = link
    },
    SET_DRAWER(state) {
        state.drawer = !state.drawer
    },
    SET_PROGESS_STATE(state, progressState) {
        state.progressState = progressState
    }
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions: {},
    modules: {file, deal, event},
    strict: true
})
